module.exports = __webpack_public_path__ + "img/folder-remove.bfcf1225.svg";